import { Button, Typography } from '@material-ui/core';
import { useFormikContext } from 'formik';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  List,
  StyledPaper,
  StyledPrice,
} from 'app/components/PricePlanOption/styles';
import { getPrice } from 'service/utils';
import { IForm } from 'app/pages/Registration/utils';

interface Props {
  yearPrice: number;
  monthPrice: number;
  title: string;
  perks: string[];
  period: 'annual' | 'monthly';

  confirmView?: boolean;
  error?: boolean;
  selected?: boolean;
  onClick?: () => void;
}

const PricePlanOption: React.FC<Props> = ({
  yearPrice,
  monthPrice,
  title,
  perks,
  period,
  error,
  selected,
  onClick,
  confirmView,
}) => {
  const {
    values: {
      companyLocations: { numberOfLocations },
    },
  } = useFormikContext<IForm>();
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLUListElement>(null);
  const price = getPrice({
    locations: numberOfLocations,
    month: monthPrice,
    period,
    year: yearPrice,
  });

  return (
    <StyledPaper
      $isOpen={isOpen}
      $selected={selected}
      $error={error}
      elevation={0}
      square
      onClick={() => {
        setIsOpen((prev) => !prev);
      }}
      $confirmView={confirmView}
    >
      <div className="title">
        <Typography variant="h6">
          {t(`registration.component.pricePlan.option.options.${title}.title`)}
        </Typography>
        <span className="expand" />
      </div>
      <Typography className="description">
        {t(
          `registration.component.pricePlan.option.options.${title}.description`,
        )}
      </Typography>
      <div className="price">
        <StyledPrice
          variant="body1"
          $afterContent={t('registration.component.pricePlan.option.price')}
        >
          {price}
        </StyledPrice>
        {!confirmView ? (
          <Button
            className="btn-select"
            color="primary"
            variant="contained"
            onClick={(e) => {
              e.stopPropagation();
              onClick?.();
            }}
          >
            {t('registration.component.pricePlan.option.select')}
          </Button>
        ) : (
          <Typography>
            {t('registration.component.pricePlan.option.description')}
          </Typography>
        )}
      </div>
      <List
        $selected={selected}
        $isOpen={isOpen}
        $height={ref.current?.scrollHeight ?? 0}
        ref={ref}
      >
        {perks.map((option) => (
          <li key={option}>
            <Typography>{option}</Typography>
          </li>
        ))}
      </List>
    </StyledPaper>
  );
};

export default PricePlanOption;
